import { useLanguageContext, useThemeContext } from "../../../../../../context";
import { observepaymentByID } from "../../../../../../pos-core/database/helpers";
import { formatDayTime, formatNum } from "../../../../../../constants";
import { NewPosHeader } from "../../../../../common/V2";
import withObservables from "@nozbe/with-observables";
import { switchMap } from "rxjs";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";

const TransactionDetail = ({ payment }) => {
  const { I18n } = useLanguageContext();
  const { theme } = useThemeContext();

  payment = payment[0];

  const {
    payment_method,
    expiry_date,
    card_number,
    created_at,
    amount,
    status,
    id,
  } = payment || {};

  const [payDetail, setPayDetail] = useState({
    order_line: [],
    loading: true,
    customer: {},
    business: {},
    netAmount: 0,
    taxAmount: 0,
    saleTax: {},
  });

  useEffect(() => {
    getPaymentDetails();
  }, []);

  const getPaymentDetails = async () => {
    let customer = await payment?.customer.fetch();
    let business = await payment.business.fetch();
    let order = await payment.order.fetch();
    let order_line = await order.order_line.fetch();
    let saleTax = await order.sales_tax.fetch();

    let netAmount, taxAmount;

    if (saleTax?.id) {
      netAmount = payment.amount - (payment.amount / 100) * saleTax.rate;
      taxAmount = (saleTax.rate / 100) * payment.amount;
    } else netAmount = payment.amount;

    setPayDetail({
      loading: false,
      order_line,
      netAmount,
      taxAmount,
      customer,
      business,
      saleTax,
    });
  };

  return (
    <section className="layoutMainBox">
      <div className="layoutMainInnerBox">
        <NewPosHeader
          backBtnCta={true}
          title={{
            name: `Transaction ID | ${id.split("-")[0]}`,
            decs: `(${formatDayTime(created_at)})`,
          }}
        />

        {payDetail.loading ? (
          <Spinner
            animation="border"
            variant="white"
            className="loaderCircle marBot25"
          />
        ) : (
          <div>
            <div>
              <p style={{ color: theme.white }}>{I18n.amount}</p>
              <div>
                <span style={{ color: theme.white }}>
                  Rs. {formatNum(amount)}
                </span>
                <span style={{ color: theme.white }}>{status}</span>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <div style={{ marginRight: "100px" }}>
                <p style={{ color: theme.white }}>{I18n.location}</p>
                <p style={{ color: theme.white }}>
                  {payDetail.business.address || "-"}
                </p>
              </div>

              <div style={{ marginRight: "100px" }}>
                <p style={{ color: theme.white }}>{I18n.customer_id}</p>
                <p style={{ color: theme.white }}>
                  {payDetail.customer?.phone_number || "-"}
                </p>
                <p style={{ color: theme.white }}>
                  {payDetail.customer?.name || "-"}
                </p>
              </div>

              <div>
                <p style={{ color: theme.white }}>{I18n.payment_method}</p>
                <p style={{ color: theme.white }}>
                  {payment_method == I18n.card
                    ? card_number || "-"
                    : payment_method == I18n.cash
                    ? "COD"
                    : payment_method == I18n.wallet
                    ? "-"
                    : "-"}
                </p>
              </div>
            </div>

            <div style={{ justifyContent: "flex-start", alignItems: "center" }}>
              <p style={{ color: theme.white }}>Items purchased</p>

              {payDetail.order_line.map((item, index) => {
                return (
                  <div key={index}>
                    <span style={{ color: theme.white, marginRight: "100px" }}>
                      {item.name}
                    </span>
                    <span style={{ color: theme.white }}>
                      Rs. {formatNum(item.selling_price)}
                    </span>
                  </div>
                );
              })}
            </div>

            <div>
              <p style={{ color: theme.white }}>Payment details</p>

              <div>
                <span style={{ color: theme.white }}>Gross amount</span>
                <span style={{ color: theme.white }}>
                  Rs. {formatNum(amount)}
                </span>
              </div>

              {payDetail.saleTax?.id ? (
                <div>
                  <span style={{ color: theme.white }}>
                    Tax {payDetail.saleTax.rate}%
                  </span>
                  <span style={{ color: theme.white }}>
                    Rs. {formatNum(payDetail.taxAmount)} (
                    {payDetail.saleTax.is_inclusive ? "inclusive" : "exclusive"}
                    )
                  </span>
                </div>
              ) : null}

              <div>
                <span style={{ color: theme.white }}>Net amount</span>
                <span style={{ color: theme.white }}>
                  Rs. {formatNum(payDetail.netAmount)}
                </span>
              </div>
            </div>

            <div>
              <p style={{ color: theme.white }}>Payment method</p>

              {card_number ? (
                <div>
                  <span style={{ color: theme.white }}>Number</span>
                  <span style={{ color: theme.white }}>{card_number}</span>
                </div>
              ) : null}

              {expiry_date ? (
                <div>
                  <span style={{ color: theme.white }}>Expires</span>
                  <span style={{ color: theme.white }}>
                    {formatDayTime(expiry_date)}
                  </span>
                </div>
              ) : null}

              <div>
                <span style={{ color: theme.white }}>Type</span>
                <p style={{ color: theme.white }}>
                  {payment_method == I18n.cash
                    ? "CASH IMAGE HERE"
                    : payment_method == I18n.card
                    ? "CARD IMAGE HERE BASED ON CARD TYPE VISA | MASTER OR OTHER"
                    : payment_method == I18n.wallet
                    ? "EASY PAISA | JAZZCASH HERE BASED ON METHOD TYPE"
                    : "Image here"}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

const enhance = withObservables([""], ({}) => {
  let id = window.location.pathname.split("/")[2];
  return {
    customer: observepaymentByID(id).pipe(
      switchMap((payments) => payments[0]?.customer.observe())
    ),
    business: observepaymentByID(id).pipe(
      switchMap((payments) => payments[0].business.observe())
    ),
    order: observepaymentByID(id).pipe(
      switchMap((payments) => payments[0]?.order.observe())
    ),
    payment: observepaymentByID(id),
  };
});

export default enhance(TransactionDetail);
